import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { VisitDetailPhotos } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';

export class AdditionalIDPhotosReviewsEndpoints {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  post(visitId: number, payload: VisitDetailPhotos.UpdatePhotoPayload) {
    return this.http.post(
      `${this.env.constants.ADMIN_API_URL}/admin/orders/${visitId}/additional/idphotos/reviews`,
      payload,
    );
  }
}
